import styles from './index.module.css'
import { FC } from 'react'

interface MenuProps {
  openModalFromMenu: () => void
}

export const Menu: FC<MenuProps> = ({openModalFromMenu}) => {
  function goToGit() {
    window.open('https://github.com/VladPashkovsky')
  }

  function toAdmin() {
    window.open('https://admin.bunch-of-stuff.ru')
  }

  return (
    <div className={styles.menu_container}>
      <div className={`${styles.navLink} ${styles.dropdown}`}>
        <h1 data-name="Menu">Menu</h1>
        <ol className={styles.sub_menu}>
          <li className={styles.menu_item} onClick={toAdmin}><a>Admin Panel</a></li>
          <li className={styles.menu_item} onClick={openModalFromMenu}><a>Contacts</a></li>
          {/*<li className={styles.menu_item}><a href="">Huge Widgets</a></li>*/}
        </ol>
      </div>
      <div className={styles.navLink}>
        <h1 data-name="GitHub" onClick={goToGit}>GitHub</h1>
      </div>
    </div>
  )
}

